export const SHOPGATE_STOREFRONT_GET_CART = 'shopgate.storefront.getCart';
export const SHOPGATE_STOREFRONT_UPDATE_CART = 'shopgate.storefront.updateProducts';
